module.exports = __webpack_public_path__ + "img/s00130.6f61b552.png";